import { useEffect } from 'react';
import {
  IAPIStudioInfo,
  IAPIStudioMemberHasPermissionItem,
} from '../../../../model/api-modules/studio';
import { IBillingAccountInfo } from '../../../../model/billing-center/overview';
import { BalanceOverviewComponent } from './balance-overview';
import { RecentMonthsChartComponent } from './recent-months-chart';
import './style.scss';
import { TotalBalanceComponent } from './total-balance';
import { auditReadLog } from '../../../lib/aduit-log';
import { IAuditItem } from '../../../../model/api-modules';

interface IProps {
  readonly studioInfo: IAPIStudioInfo;
  readonly balanceList: IBillingAccountInfo | null;
  readonly members?: ReadonlyArray<IAPIStudioMemberHasPermissionItem>;
}

export const BillingOverviewComponent = (props: IProps) => {
  useEffect(() => {
    auditReadLog(IAuditItem.ViewBilling);
  }, []);
  return (
    <div className="bi-overview">
      <div className="bi-overview-top">
        <TotalBalanceComponent
          studioInfo={props.studioInfo}
          balanceList={props.balanceList}
          members={props.members}
        />
        <RecentMonthsChartComponent
          studioId={props.studioInfo.studio.StudioID}
        />
      </div>
      <div className="bi-overview-bottom">
        <BalanceOverviewComponent studioId={props.studioInfo.studio.StudioID} />
      </div>
    </div>
  );
};
